module.exports = __webpack_public_path__ + "static/img/title-dq.cb51c68.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/title-dq.png
// module id = 8JH6
// module chunks = 41